import EVLevelIcon from './LevelIcon'

export default EVLevelIcon
